export const EXCEPTION_CURRENCIES_FOR_DECIMAL_HIDE = ['VND','KRW','JPY','XOF'];
export const HIDE_DECIMALS_FOR_VALUES = new Set(['00']);